var _circle, _path, _circle2, _circle3, _circle4, _path2, _circle5, _circle6, _g, _circle7, _circle8, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAnswerIcon = function SvgAnswerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#A0C89B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.366 44.084c0 15.916-13.365 23.25-23.48 23.25s-23.48-8-23.48-23.25c0-15.575 13.229-27.347 19.827-32.25 2.173-1.615 5.085-1.55 7.203.135 6.563 5.219 19.93 17.627 19.93 32.115Z",
    fill: "#FF696A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.887,
    cy: 45.161,
    fill: "#FFE8E0",
    r: 18.667
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.806,
    cy: 45.428,
    r: 1.345,
    fill: "#503917"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.218,
    cy: 45.428,
    r: 1.345,
    fill: "#503917"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.873 48.865a3.436 3.436 0 1 1-6.873 0H42.873Z",
    fill: "#FF696A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.887,
    cy: 45.161,
    fill: "#FFE8E0",
    r: 18.667
  })), /*#__PURE__*/React.createElement("mask", {
    id: "answer_icon_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 26,
    width: 38,
    height: 38
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.887,
    cy: 45.161,
    fill: "#FFE8E0",
    r: 18.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#answer_icon_svg__a)",
    fill: "#FFCDCD"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.999,
    cy: 52.667,
    r: 7.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.667,
    cy: 52.667,
    r: 7.333
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.806,
    cy: 45.428,
    r: 1.345,
    fill: "#503917"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.218,
    cy: 45.428,
    r: 1.345,
    fill: "#503917"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.873 48.865a3.436 3.436 0 1 1-6.873 0H42.873Z",
    fill: "#FF696A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.67 30.407c-.732-3.607 2.11-5.246 5.23-5.246 3.12 0 5.858 1.53 5.23 5.246-.295 1.326-.84 2.549-1.471 3.62-1.724 2.927-5.754 2.896-7.509-.013-.66-1.094-1.219-2.323-1.48-3.607Z",
    fill: "#503917"
  })));
};
export default SvgAnswerIcon;